var PLTTelemetryEventNames = /* @__PURE__ */ ((PLTTelemetryEventNames2) => {
  PLTTelemetryEventNames2["PLT_App_initialize"] = "App:initialize";
  PLTTelemetryEventNames2["PLT_App_start"] = "PLT:App:start";
  PLTTelemetryEventNames2["PLT_Shell_Rendered"] = "Shell:Rendered";
  PLTTelemetryEventNames2["PLT_Loader_main"] = "PLT:Loader:main";
  PLTTelemetryEventNames2["PLT_Loader_main_setPath"] = "PLT:Loader:main:after:setPath";
  PLTTelemetryEventNames2["PLT_App_Init_Experience"] = "PLT:App_Init_Experience";
  PLTTelemetryEventNames2["PLT_RouteView"] = "PLT:RouteView";
  PLTTelemetryEventNames2["PLT_Bootstrap_PingLoadingAfter"] = "PLT:Bootstrap:PingLoadingAfter";
  return PLTTelemetryEventNames2;
})(PLTTelemetryEventNames || {});
export {
  PLTTelemetryEventNames
};
//# sourceMappingURL=PLTTelemetryEventNames.js.map
